import { catalog, selectedChannel } from './admin-globals.js';
import { authHeaders } from './admin-auth.js';
import { showToast } from './admin-ui-base.js';
import { canEditChannel } from './catalog-ui.js';
import { loadCatalog } from './catalog-api.js';

export function openPlaylistImport() {
  const ch = catalog[selectedChannel];
  if (!ch) {
    showToast('SELECCIONA UN CANAL', true);
    return;
  }
  if (!canEditChannel(ch)) {
    showToast('CANAL EN SOLO LECTURA', true);
    return;
  }
  document.getElementById('playlist-import-input').value = '';
  document.getElementById('playlist-import-modal').classList.remove('hidden');
  document.getElementById('playlist-import-input').focus();
}

export function closePlaylistImport() {
  document.getElementById('playlist-import-modal').classList.add('hidden');
}

export async function submitPlaylistImport() {
  const raw = document.getElementById('playlist-import-input').value.trim();
  if (!raw) {
    showToast('PEGA UNA URL DE PLAYLIST', true);
    return;
  }
  const ch = catalog[selectedChannel];
  if (!ch?.id) return;

  const btn = document.getElementById('playlist-import-submit');
  if (btn) {
    btn.disabled = true;
    btn.textContent = 'IMPORTANDO…';
  }

  try {
    const res = await fetch('/api/youtube/playlist/import', {
      method: 'POST',
      headers: { ...authHeaders(), 'Content-Type': 'application/json' },
      body: JSON.stringify({
        playlist: raw,
        channel_id: ch.id,
        append: true,
      }),
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) {
      const msg = typeof data.detail === 'string' ? data.detail : data.detail?.detail || 'ERROR';
      showToast(String(msg).slice(0, 80).toUpperCase(), true);
      return;
    }
    closePlaylistImport();
    await loadCatalog({ channelId: ch.id });
    showToast(
      `BIBLIOTECA +${data.library_upserted} · CANAL +${data.videos_added} (${data.items_found} en playlist)`
    );
  } catch (e) {
    showToast('ERROR DE CONEXIÓN', true);
    console.error(e);
  } finally {
    if (btn) {
      btn.disabled = false;
      btn.textContent = 'IMPORTAR';
    }
  }
}
